var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"animate-m",rawName:"v-animate-m",value:({name:'fadeIn',delay:'0.3s'}),expression:"{name:'fadeIn',delay:'0.3s'}"}],attrs:{"id":"app"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }